import "./Loader.css";
import useFetch from "../hooks/useFetch";
import config from "../config";

const Loader = () => {
  //ignore pro loading a error, ktere nepouzivame
  // eslint-disable-next-line
  const { loading, error, data } = useFetch(
    `${config.api}/api/navbar?populate=*`
  );

  //? test
  //?console.log(error);
  //?console.log(loading);
  return (
    <div className="loader-container">
      <img
        src={`${config.api}${data?.data?.logo?.url}`}
        alt={data?.data?.logo?.alternativeText}
        className="loader-image"
      />
      <div className="loader"></div>
    </div>
  );
};
export default Loader;
